import * as actionTypes from './actionTypes';

export const wizardFinished = () => {
  return {
      type: actionTypes.SET_WIZARD_FINISHED
    };
};

export const wizardUnfinished = () => {
  return {
      type: actionTypes.SET_WIZARD_UNFINISHED
    };
};

export const getWizardFinishedStatus = (state) => {
  return state.stats['wizard_finished_status'];
}



// WEBPACK FOOTER //
// ./src/store/actions/stats.js